import { Box, Container, Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/layouts/page-layout';
// import { NewsBlock } from './news-block';
import { _Locale } from '../commissions/BasicTable';
import data from './data.json';

export const Instruction: ComponentType = () => {
  const { t, i18n } = useTranslation();
  return (
    <PageLayout
      title={t('instruction.title', 'Инструкции')}
      subtitle={t(
        'instruction.subtitle',
        '“Тиббиёт ва фармацевтика ходимларига малака тоифаси бериш бўйича аттестациядан ўтказиш ва уларга сертификат бериш” ягона ахборот тизимида (tibtoifa.ssv.uz) ҳужжат топшириш бўйича'
      )}
    >
      <Container>
        {/* <NewsBlock showItems={9} pb={9} loadMoreBtn /> */}
        <Box pb={5}>
          {data[i18n.language as _Locale].map((d, idx) => (
            <Typography my={2}>
              {idx + 1}. {d}
            </Typography>
          ))}
        </Box>
      </Container>
    </PageLayout>
  );
};
